<template>
  <Modal :id="'cmp-add-user'" @cancelled="onCancel">
    <template slot="header">
      {{ $t('create_external_user') }}
    </template>
    <template slot="body">
      <div class="form-group login-white">
        <!-- <TextField
          class="m1"
          :id="'new_username'"
          required
          v-bind="textFieldConfig"
          v-model="username"
          isModel
          :placeholder="$t('user_name')"
          :autocomplete="'off'"
        ></TextField> -->
        <TextField :id="'user_name'" class="m1" v-bind="textFieldConfig" v-model="user_name" isModel
          :placeholder="$t('user_name')" @valuechanged="onUserNameChange" showValidationIcons required
          :validators="uniqueNameValidator" @validated="onValidation" />
        <TextField class="m1" :id="'given_name'" required v-bind="textFieldConfig" v-model="given_name" isModel
          :placeholder="$t('Given name')"></TextField>
        <!-- <TextField
          class="m1"
          :id="'new_email'"
          required
          v-bind="textFieldConfig"
          v-model="email"
          isModel
          :placeholder="$t('email_1')"
        ></TextField> -->
        <TextField :id="'email'" class="m1" type="email" v-bind="textFieldConfig" v-model="email" isModel required
          showValidationIcons :placeholder="$t('email')" :validators="emailValidators" @valuechanged="onEmailChange"
          @validated="onValidation" />
        <Dropdown :options="systemLanguagesTV || []" :selected="selectedLanguage" class="m2"
          :placeholder="$t('language')" v-on:selectedChange="(e) => (selectedLanguage = e)" :listHeight="95" box>
        </Dropdown>
      </div>

    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
      <button :disabled="!isFormValid" :class="{ disabled: !isFormValid }" class="dt-button v1 with-ico s6"
        @click.stop="onAddUser">

        <div class="button-text">
          {{ $t("Add External User") }}
        </div>
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { mapGetters } from "vuex";
import { subscribeSubject } from "../../../../utility";
import { Subject } from "rxjs";
import {
  createTextFieldConfig,
  EventHooks,
} from "../../../../plugins/text-field";
import { createValidator } from "@plugins/text-field";
import isEmail from "validator/lib/isEmail";
import { AccountsService } from "../../../../modules/royalty/services/accounts.service";
import {
  NotificationService,
} from "../../../../dt-plugins/notification/notification.service";
export default {
  components: {
    Modal,
  },
  props: {},
  data: function () {
    return {
      user_name: "",
      password: "",
      email: "",
      given_name: "",
      selectedLanguage: null,
      validationResult: {},
      userNameSubject: new Subject(),
      emailNameSubject: new Subject(),
      duplicateUserName: "",
      duplicateEmail: null,
      textFieldConfig: createTextFieldConfig({
        height: 42,
        showEditIconOnHover: false,
        box: true,
        //showValidationIcons: true,
        immediateValidation: true,
        // validationEvent: EventHooks.OnKeyup,
        // valueChangedEvent: EventHooks.OnKeyup,
      }),
      // Mark: Data
    };
  },
  mounted() {
    subscribeSubject(this, this.userNameSubject, async (value) => {
      const checkUnique = await AccountsService.checkUniquenessOfExternalUser(
        value
      );
      const is_unique = checkUnique.data.is_unique;
      if (!is_unique) {
        this.duplicateUserName = value;
        const temp = this.user_name;
        this.user_name = null;
        this.$nextTick(() => {
          this.user_name = temp;
        });
      }

    });
    subscribeSubject(this, this.emailNameSubject, async (value) => {
      const checkUnique = await AccountsService.checkUniquenessOfExternalUserEmail(
        value
      );
      const is_email_taken = checkUnique.data.is_email_taken;
      if (is_email_taken) {
        this.duplicateEmail = value
        this.email = null;
        this.$nextTick(() => {
          this.email = value;
        });
        NotificationService.showNotification({
          text: this.$t('external_user_email_taken'),
          timeout: 3000,
          type: "error",
        });
      }



    });
  },
  watch: {
    systemLanguagesTV: {
      immediate: true,
      handler: function (to, from) {
        if (to) {
          this.selectedLanguage = to[0];
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      systemLanguagesTV: "systemLanguagesTV",
    }),
    uniqueNameValidator() {
      return [
        createValidator({
          name: "uniqName",
          validatorFn: this.checkUserNameUniq,
          errorMessage: "Name is already exist",
        }),
      ];
    },
    emailValidators() {
      return [
        createValidator({
          name: "emailValidation",
          validatorFn: isEmail,
          errorMessage: "Must be a valid Email",
        }),
        createValidator({
          name: "uniqEmail",
          validatorFn: this.checkEmailUniq,
          errorMessage: "Email is already exist",
        }),
      ];
    },
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
    user: function () {
      return {
        user_name: this.user_name,
        given_name: this.given_name,
        email: this.email,
        password: this.password,
        language: this.selectedLanguage.value,
      };
    },
    isExternal: function () {
      return (
        this.$route.query["external"] == "true" ||
        this.$route.query["external"] == true
      );
    },
  },
  methods: {
    async onEmailChange(name, value) {
      if (isEmail(value)) {
        this.email = value;
        this.emailNameSubject.next(value);
      }
    },
    async onUserNameChange(name, value) {
      this.user_name = value;
      this.userNameSubject.next(value);
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },

    checkUserNameUniq(value) {
      return value == this.duplicateUserName ? false : true;
    },
    checkEmailUniq(value) {
      return value == this.duplicateEmail ? false : true;
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onAddUser: function () {
      this.$emit("added", this.user);
    },
    // Mark: Methods
  },
};
</script>

<style lang="scss" scoped></style>
